"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSegmentedControl = exports.StyledSegmentedControlItem = exports.StyledSegmentText = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
const utils_2 = require("./utils");
exports.StyledSegmentText = (0, styled_components_1.default)(general_1.Typography) `
  width: 100%;
  text-align: center;
  color: ${theme_1.grayScale[900]};
`;
exports.StyledSegmentedControlItem = (0, styled_components_1.default)(general_1.Flexbox) `
  ${(props) => {
    const { activeSegment, currentElement, isVertical, isFilled, customStyles = {}, } = props;
    const isActive = Boolean(activeSegment === currentElement);
    return (0, styled_components_1.css) `
      ${!isVertical &&
        (0, styled_components_1.css) `
        flex: 1;
        flex-basis: ${(0, utils_1.pxToRem)(110)};
      `}
      flex-shrink: 0;
      padding: ${(0, utils_1.pxToRem)(10)} ${theme_1.spacings.s4};
      width: 100%;
      cursor: pointer;
      background-color: ${isFilled ? '#faffe2' : theme_1.grayScale[200]};
      height: ${theme_1.spacings.s9};
      & * {
        transition: all 0.3s;
      }

      &:hover {
        ${(0, utils_2.GetLabelHoverStyles)(isActive)}
      }

      &:focus-visible,
      &:focus-within {
        ${exports.StyledSegmentText} {
          box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.dark, theme_1.primary.dark)};
          border-radius: ${theme_1.spacings.s1};
          font-weight: 500;
          color: ${theme_1.primary.dark};
        }

        ${isActive && (0, utils_2.getFocusStyles)(theme_1.primary.dark)}
      }

      ${(0, utils_2.GetSegmentActiveStyles)(isActive)}
      ${{ ...customStyles }}
    `;
}}
`;
exports.StyledSegmentedControl = (0, styled_components_1.default)(general_1.Flexbox) `
  padding: ${(0, utils_1.pxToRem)(10)};
`;
//# sourceMappingURL=styles.js.map